import React from 'react';

import styled from 'styled-components';
import Title2 from '@joinforma/ui/components/Title2';

import Body2 from '@joinforma/ui/components/Body2';
import { COLORS } from '@joinforma/ui/constants/themes';
import Currency from 'components/common/Currency';

const Container = styled.div`
  background-color: ${COLORS.CYAN_200};
  padding: 12px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const Message = styled(Body2)``;

const Amount = styled(Title2)``;

const AccountBalanceBanner = ({
  amount,
  num_of_accounts,
  currency,
}: {
  amount: number;
  num_of_accounts: number;
  currency: string;
}) => (
  <Container>
    <Message>
      {`You currently have a total of `}
      <Amount>
        <Currency amount={amount} currency={currency} />
      </Amount>
      {` across ${num_of_accounts} accounts that you can use in the store.`}
    </Message>
  </Container>
);

export default AccountBalanceBanner;
